import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableLazyLoadEvent } from 'primeng/table';
import { MonitoringTreatments } from '../../models/monitoring.model';
import { MonitoringService } from '../../services/monitoring.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-monitoring-treatment',
  templateUrl: './monitoring-treatment.component.html',
  styleUrl: './monitoring-treatment.component.scss',
})
export class MonitoringTreatmentComponent implements OnInit, OnDestroy {
  private readonly router: Router = inject(Router);
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly monitoringService: MonitoringService =
    inject(MonitoringService);
  private subscription: Subscription | undefined;

  monitoringID: string = '';
  fileName: string = '';
  treatmentData: MonitoringTreatments | null = null;
  loading: boolean = true;
  pageSize: number = 200;
  first: number = 0;
  rowsPerPageOptions: number[] = [200, 500, 1000];

  // Getter pour générer dynamiquement le tableau pour le skeleton loading
  get loadingArray(): number[] {
    return Array(this.pageSize)
      .fill(0)
      .map((_, i) => i);
  }

  constructor() {}

  ngOnInit(): void {
    this.subscription = this.route.params.subscribe((params) => {
      this.monitoringID = params['id'];
    });

    // Récupérer le nom du fichier depuis le state de navigation sinon on reviens à la page de monitoring
    this.fileName = history.state?.fileName ?? null;
    if (!this.fileName) this.router.navigate([`monitoring/`]);
  }

  loadData(event: TableLazyLoadEvent): void {
    if (!this.monitoringID) {
      console.error('No monitoring ID provided');
      this.loading = false;
      return;
    }

    this.loading = true;
    const first = event.first ?? 0;
    this.pageSize = event.rows ?? this.pageSize;

    // Calculer la page correctement pour l'API
    const page = Math.floor(first / this.pageSize) + 1;

    // Mettre à jour la propriété first pour la synchronisation avec PrimeNG
    this.first = first;

    this.monitoringService
      .getPaginatedTreatment(this.monitoringID, page, this.pageSize)
      .subscribe({
        next: (data: MonitoringTreatments) => {
          this.treatmentData = data;
          this.loading = false;
        },
        error: (error: unknown) => {
          console.error('Error loading treatment data:', error);
          this.loading = false;
        },
      });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
